import { createContext } from 'react-router';

/**
 * Router contexts used to pass request-scoped data from middleware to loaders
 * in React Router v8's native middleware pipeline.
 *
 * Middleware populates these via `context.set(...)`; loaders read them via
 * `context.get(...)`. Each context is created with a concrete default value so
 * `context.get(...)` never throws for a route whose middleware did not populate
 * it (e.g. public routes, or an unauthenticated navigation).
 */

/**
 * Access token resolved by `rootMiddleware`; empty string when unauthenticated.
 *
 * The `''` default is load-bearing: on routes where `rootMiddleware` does not
 * run (public routes) or in the no-token path, loaders read this value and
 * treat `''` as "unauthenticated". Do not change it to `undefined` — that
 * removes the registered default and makes `context.get(...)` throw.
 */
export const accessTokenContext = createContext<string>('');

/**
 * Navigation actions the current principal is allowed to perform.
 *
 * The `[]` default is load-bearing: the no-token path in `rootMiddleware`
 * never sets this context, and `rootLoader` reads it unconditionally. `[]`
 * means "no permissions". Do not change it to `undefined` — that removes the
 * registered default and makes `context.get(...)` throw. The no-token
 * middleware test asserts this default, so a change here fails that test.
 */
export const allowedNavActionsContext = createContext<string[]>([]);
